// Audio Management Module
class AudioManager {
    constructor() {
        // Audio setup for custom sound files - multiple click sounds
        this.clickSounds = [
            new Audio('/audio/12mf.mp3'),
            new Audio('/audio/readygoodsir.wav')
        ];
        this.clickSounds.forEach(sound => {
            sound.volume = 1.0; // Adjust volume (0.0 to 1.0)
        });
        
        this.powerupSound = new Audio('/audio/whatisit.wav');
        this.powerupSound.volume = 0.8;
        
        this.gameOverSound = new Audio('/audio/fuckeditup.wav');
        this.gameOverSound.volume = 0.8;
        
        // Background music setup
        this.backgroundMusic = new Audio('/audio/bg-sharks.mp3');
        this.backgroundMusic.volume = 0.3; // Lower volume for background music
        this.backgroundMusic.loop = true; // Loop continuously
        this.musicMuted = false; // Track music mute state
        
        // Bonus round music
        this.bonusMusic = new Audio('/audio/boys.mp3');
        this.bonusMusic.volume = 0.3;
        this.bonusMusic.loop = true;
        this.originalMusicPosition = 0; // Track position for resuming
        
        // Handler for background music events
        this.backgroundMusicHandler = null;
        
        // Handler for click sound ended events
        this.clickSoundEndedHandler = null;
        
        // Fallback to Web Audio API if custom sound fails
        this.audioContext = null;
        
        this.initializeAudioContext();
    }
    
    initializeAudioContext() {
        // Initialize audio context on first user interaction
        document.addEventListener('click', () => {
            if (!this.audioContext) {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            }
        }, { once: true });
    }
    
    playSound(gameStarted, startBackgroundMusicCallback) {
        try {
            // Randomly select one of the click sounds
            const randomIndex = Math.floor(Math.random() * this.clickSounds.length);
            const selectedSound = this.clickSounds[randomIndex];
            
            // Reset to beginning and clean up any previous state
            selectedSound.currentTime = 0;
            
            // Remove any existing 'ended' event listeners to prevent conflicts
            selectedSound.removeEventListener('ended', this.clickSoundEndedHandler);
            
            // Start background music after click sound finishes (if game will start)
            if (!gameStarted) {
                // Create a handler we can properly remove later
                this.clickSoundEndedHandler = () => {
                    startBackgroundMusicCallback();
                };
                selectedSound.addEventListener('ended', this.clickSoundEndedHandler, { once: true });
            }
            
            selectedSound.play().catch(error => {
                console.log('Custom audio failed, using fallback:', error);
                this.playFallbackSound();
                // Still start background music if click sound fails
                if (!gameStarted) {
                    setTimeout(() => startBackgroundMusicCallback(), 200); // Small delay
                }
            });
        } catch (error) {
            console.log('Audio playback error:', error);
            this.playFallbackSound();
            // Still start background music if click sound fails
            if (!gameStarted) {
                setTimeout(() => startBackgroundMusicCallback(), 200); // Small delay
            }
        }
    }
    
    playFallbackSound() {
        // Fallback to Web Audio API if custom sound fails
        if (!this.audioContext) {
            try {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            } catch (error) {
                console.log('Web Audio API not available');
                return;
            }
        }
        
        try {
            // Create a simple beep sound using Web Audio API
            const oscillator = this.audioContext.createOscillator();
            const gainNode = this.audioContext.createGain();
            
            oscillator.connect(gainNode);
            gainNode.connect(this.audioContext.destination);
            
            // Configure the sound
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
            oscillator.frequency.exponentialRampToValueAtTime(400, this.audioContext.currentTime + 0.1);
            
            // Configure volume envelope
            gainNode.gain.setValueAtTime(0, this.audioContext.currentTime);
            gainNode.gain.linearRampToValueAtTime(0.3, this.audioContext.currentTime + 0.01);
            gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + 0.2);
            
            // Play the sound
            oscillator.start(this.audioContext.currentTime);
            oscillator.stop(this.audioContext.currentTime + 0.2);
            
        } catch (error) {
            console.log('Error playing fallback sound:', error);
        }
    }
    
    playPowerupSound() {
        try {
            // Try to play custom powerup audio file
            this.powerupSound.currentTime = 0; // Reset to beginning
            this.powerupSound.play().catch(error => {
                console.log('Custom powerup audio failed, using fallback:', error);
                this.playFallbackCollectionSound();
            });
        } catch (error) {
            console.log('Powerup audio playback error:', error);
            this.playFallbackCollectionSound();
        }
    }
    
    playGameOverSound() {
        try {
            // Try to play custom game over audio file
            this.gameOverSound.currentTime = 0; // Reset to beginning
            this.gameOverSound.play().catch(error => {
                console.log('Custom game over audio failed:', error);
            });
        } catch (error) {
            console.log('Game over audio playback error:', error);
        }
    }
    
    playFallbackCollectionSound() {
        // Fallback collection sound using Web Audio API
        if (!this.audioContext) {
            try {
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            } catch (error) {
                console.log('Web Audio API not available');
                return;
            }
        }
        
        try {
            const oscillator = this.audioContext.createOscillator();
            const gainNode = this.audioContext.createGain();
            
            oscillator.connect(gainNode);
            gainNode.connect(this.audioContext.destination);
            
            // Configure a cheerful collection sound
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(1200, this.audioContext.currentTime);
            oscillator.frequency.exponentialRampToValueAtTime(1600, this.audioContext.currentTime + 0.1);
            
            // Configure volume envelope
            gainNode.gain.setValueAtTime(0, this.audioContext.currentTime);
            gainNode.gain.linearRampToValueAtTime(0.2, this.audioContext.currentTime + 0.01);
            gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + 0.15);
            
            // Play the sound
            oscillator.start(this.audioContext.currentTime);
            oscillator.stop(this.audioContext.currentTime + 0.15);
            
        } catch (error) {
            console.log('Error playing fallback collection sound:', error);
        }
    }
    
    startBackgroundMusic() {
        if (this.musicMuted) {
            console.log('Background music is muted, not starting');
            return;
        }
        
        try {
            // Reset to beginning and play background music
            this.backgroundMusic.currentTime = 0;
            
            // Remove any existing event listeners to prevent duplicates
            this.backgroundMusic.removeEventListener('canplaythrough', this.backgroundMusicHandler);
            
            // Create a handler function that we can properly remove
            this.backgroundMusicHandler = () => {
                this.backgroundMusic.play().catch(error => {
                    console.log('Background music failed to start:', error);
                    console.log('This might be due to browser autoplay policy - user interaction required');
                });
            };
            
            // Add loaded event listener to ensure audio is ready
            this.backgroundMusic.addEventListener('canplaythrough', this.backgroundMusicHandler, { once: true });
            
            // If already loaded, play immediately
            if (this.backgroundMusic.readyState >= 3) { // HAVE_FUTURE_DATA
                this.backgroundMusic.play().catch(error => {
                    console.log('Background music failed to start:', error);
                    console.log('This might be due to browser autoplay policy - user interaction required');
                });
            } else {
                // Force load the audio
                this.backgroundMusic.load();
            }
        } catch (error) {
            console.log('Background music error:', error);
        }
    }
    
    stopBackgroundMusic() {
        try {
            // Remove any pending event listeners
            if (this.backgroundMusicHandler) {
                this.backgroundMusic.removeEventListener('canplaythrough', this.backgroundMusicHandler);
                this.backgroundMusicHandler = null;
            }
            
            // Clean up click sound handlers from all click sounds
            if (this.clickSoundEndedHandler) {
                this.clickSounds.forEach(sound => {
                    sound.removeEventListener('ended', this.clickSoundEndedHandler);
                });
                this.clickSoundEndedHandler = null;
            }
            
            this.backgroundMusic.pause();
            this.backgroundMusic.currentTime = 0;
            this.bonusMusic.pause();
            this.bonusMusic.currentTime = 0;
        } catch (error) {
            console.log('Background music stop error:', error);
        }
    }
    
    pauseBackgroundMusic() {
        try {
            this.backgroundMusic.pause();
            this.bonusMusic.pause();
        } catch (error) {
            console.log('Background music pause error:', error);
        }
    }
    
    resumeBackgroundMusic() {
        try {
            if (!this.musicMuted) {
                this.backgroundMusic.play().catch(error => {
                    console.log('Background music resume failed:', error);
                });
            }
        } catch (error) {
            console.log('Background music resume error:', error);
        }
    }
    
    stopAllAudio() {
        try {
            // Stop all background music
            this.stopBackgroundMusic();
            
            // Stop any playing sound effects
            if (this.clickSounds) {
                this.clickSounds.forEach(sound => {
                    sound.pause();
                    sound.currentTime = 0;
                });
            }
            
            if (this.powerupSound) {
                this.powerupSound.pause();
                this.powerupSound.currentTime = 0;
            }
            
            if (this.gameOverSound) {
                this.gameOverSound.pause();
                this.gameOverSound.currentTime = 0;
            }
        } catch (error) {
            console.log('Stop all audio error:', error);
        }
    }
    
    toggleMute() {
        this.musicMuted = !this.musicMuted;
        
        // Show mute indicator
        const muteIndicator = document.getElementById('muteIndicator');
        if (muteIndicator) {
            if (this.musicMuted) {
                muteIndicator.classList.add('show');
                setTimeout(() => muteIndicator.classList.remove('show'), 2000);
            }
        }
        
        if (this.musicMuted) {
            this.backgroundMusic.pause();
            this.bonusMusic.pause();
            console.log('🔇 Background music muted');
        } else {
            console.log('🔊 Background music unmuted - resuming playback');
            // Resume background music if it was playing before
            if (this.backgroundMusic.currentTime > 0 || this.bonusMusic.currentTime > 0) {
                // If bonus music was playing, resume it
                if (this.bonusMusic.currentTime > 0) {
                    this.bonusMusic.play().catch(error => {
                        console.log('Failed to resume bonus music:', error);
                    });
                } else {
                    // Resume background music
                    this.backgroundMusic.play().catch(error => {
                        console.log('Failed to resume background music:', error);
                    });
                }
            }
        }
    }
    
    switchToBonusMusic() {
        if (this.musicMuted) return;
        
        try {
            // Store current position of background music
            this.originalMusicPosition = this.backgroundMusic.currentTime;
            
            // Start bonus music at low volume
            this.bonusMusic.currentTime = 0;
            this.bonusMusic.volume = 0;
            this.bonusMusic.play().catch(error => {
                console.log('Bonus music failed to start:', error);
            });
            
            // Crossfade: fade out background, fade in bonus (1 second transition)
            const fadeSteps = 20;
            const fadeInterval = 50; // 50ms per step = 1 second total
            let step = 0;
            
            const crossfade = setInterval(() => {
                step++;
                const progress = step / fadeSteps;
                
                // Fade out background music
                this.backgroundMusic.volume = 0.3 * (1 - progress);
                // Fade in bonus music
                this.bonusMusic.volume = 0.3 * progress;
                
                if (step >= fadeSteps) {
                    clearInterval(crossfade);
                    this.backgroundMusic.pause(); // Pause only after fade out
                    console.log('🎵 Crossfaded to bonus music');
                }
            }, fadeInterval);
            
        } catch (error) {
            console.log('Error switching to bonus music:', error);
        }
    }
    
    switchToOriginalMusic() {
        if (this.musicMuted) return;
        
        try {
            // Resume background music from where it was paused at low volume
            this.backgroundMusic.currentTime = this.originalMusicPosition;
            this.backgroundMusic.volume = 0;
            this.backgroundMusic.play().catch(error => {
                console.log('Background music failed to resume:', error);
            });
            
            // Crossfade: fade out bonus, fade in background (1 second transition)
            const fadeSteps = 20;
            const fadeInterval = 50; // 50ms per step = 1 second total
            let step = 0;
            
            const crossfade = setInterval(() => {
                step++;
                const progress = step / fadeSteps;
                
                // Fade out bonus music
                this.bonusMusic.volume = 0.3 * (1 - progress);
                // Fade in background music
                this.backgroundMusic.volume = 0.3 * progress;
                
                if (step >= fadeSteps) {
                    clearInterval(crossfade);
                    this.bonusMusic.pause(); // Pause only after fade out
                    this.bonusMusic.currentTime = 0;
                    console.log('🎵 Crossfaded back to original music');
                }
            }, fadeInterval);
            
        } catch (error) {
            console.log('Error switching back to original music:', error);
        }
    }
}

// ES6 export for Vite
export default AudioManager;